import * as yup from "yup";

const LoginValidacion = yup.object().shape({
    username: yup.string().required(),
    password: yup.mixed().required()
});

export default LoginValidacion;